export interface GetAssetRequest {
    blobClientName: string;
    blobContainerName: string;
    fileName: string;
}

export interface AssetResponse {
    url: string;
}